import { sanitize } from 'lib/sanitizeHtml';
import { createElement, type HTMLAttributes, type ReactNode } from 'react';

interface SafeHtmlProps extends HTMLAttributes<HTMLElement> {
	children?: ReactNode;
	html?: string | null | undefined;
	as?: keyof React.JSX.IntrinsicElements;
}

/**
 * Renders sanitized HTML content safely.
 * Strips all tags except those in the safelist.
 * Can accept content either as children or via the html prop.
 */
const SafeHtml = ({ children, html, as = 'div', ...props }: SafeHtmlProps) => {
	// Use children if provided (as string), otherwise use html prop
	const content = typeof children === 'string' ? children : html;
	const sanitized = content ? sanitize(content) : '';

	return createElement(as, {
		...props,
		dangerouslySetInnerHTML: { __html: sanitized },
	});
};

export default SafeHtml;
